class ApiResponse {
    /** @param {{status: boolean, data: Object, message: String}} response */
    constructor(response) {
        this.status = response.status;
        this.data = response.data;
        this.message = response.message;
    }

    /** @return {boolean} */
    isSuccess() {
        return this.status;
    }

    /** @return {boolean} */
    isFailure() {
        return !this.status;
    }

    /** @return {Boolean} */
    hasMessage() {
        return !(!this.message || this.message.length === 0);
    }

    /** @return {String} */
    getMessage() {
        return this.message;
    }

    /** @return {String} */
    getErrorMessage() {
        if (this.isSuccess()) {
            return '';
        }

        let firstError = this.get('firstError');

        return firstError ? firstError : this.getMessage();
    }

    /**
     * @param {string} key
     * @param defaultValue
     */
    get(key, defaultValue = null) {
        if (this.data[key] === undefined) {
            return defaultValue;
        }

        return this.data[key];
    }
}

export {ApiResponse};
